// TODO: dont
export const times_hours: Array<IOption> = Array.from(Array(24).keys()).map(
  x => {
    return {
      label: x < 10 ? `0${x}:00` : `${x}:00`,
      value: x,
    };
  },
);
// TODO: check
export const work_times: Array<IOption> = Array.from(
  {length: 60},
  (_, i) => i + 1,
).map(x => {
  return {
    label: x.toString(),
    value: x,
  };
});

// TODO: check
export const account_types: Array<IOption> = [
  {value: 'store', label: 'فروشگاه'},
  {value: 'lab', label: 'آزمایشگاه'},
  {value: 'mechanization_service', label: 'خدمات مکانیزاسیون'},
  {value: 'worker', label: 'نیروی کار'},
  {value: 'farm', label: 'اجاره و فروش مزرعه و باغ'},
];
